import * as React from 'react';
import { Link, NavLink, RouteComponentProps, withRouter } from 'react-router-dom';

interface IScrollTopProps extends RouteComponentProps<{ language: string }> {}

class ScrollToTop extends React.Component<IScrollTopProps> {
  constructor(props: IScrollTopProps) {
    super(props);
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.location.pathname !== prevProps.location.pathname && window && window.scroll) {
       window.scroll(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/components/ScrollTop/ScrollTop.tsx